import _ from "lodash";
import { memo } from "react";
import { FormattedMessage } from "react-intl";

interface IProps {
  value?: boolean | string | number | null;
}

const HistoryLogDiffCell = ({ value }: IProps) => {
  const getDiffDisplayValue = (value?: boolean | string | number | null) => {
    if (_.isBoolean(value)) {
      return value ? (
        <FormattedMessage id="general.true" />
      ) : (
        <FormattedMessage id="general.false" />
      );
    }

    if (!value) {
      return (
        <em>
          <FormattedMessage id="general.nothing" defaultMessage={"Nothing"} />
        </em>
      );
    }

    return value;
  };

  return <span>{getDiffDisplayValue(value)}</span>;
};

export default memo(HistoryLogDiffCell);
